/**
 * Decoupling padination from main thread to prevent future issues with pagination
 *
 * @props
 * data: Object
 * selectedOptions: Array
 */
var PaginationMixin = {
  data: function () {
    return {
      currentPage: 0,
      lastPage: 0,
    };
  },
  computed: {
    paginationCurrentPage: function () {
      return this.currentPage;
    },
  },
  methods: {
    paginationSoftReset: function () {
      //   console.log("pagination soft reset");
      this.duplicateClearStack();
      this.currentPage = 1;
    },
    paginationHardReset: function () {
      //   console.log("pagination hard reset");
      this.duplicateClearStack();
      this.currentPage = 0;
    },
    paginationNextPage: function () {
      //   console.log("pagination increasing page count");
      this.lastPage = this.currentPage;
      this.currentPage = this.currentPage + 1;
    },
  },
};
export default PaginationMixin;
